import React from 'react';

import {useCurrentUserState} from 'app/current-user/api';
import {
  ACCOUNT_OVERVIEW_BULK_USER_SPREADSHEET_URL,
  ACCOUNT_OVERVIEW_BULK_USER_UPLOAD_URL,
} from 'app/urls';
import {gt} from 'app/utils/i18n';
import {getCSRFToken} from 'app/utils/urls';

export function NewMembersBulk() {
  const currentUser = useCurrentUserState().data!;

  const csrftoken = getCSRFToken();

  if (!currentUser.is_super_manager) {
    return null;
  }
  return (
    <div>
      <h4 className="border-bottom pb-1">{gt('Add New Members in Bulk')}</h4>
      <p>
        {gt(
          'Simply download and fill out %(link)s with the Name, Email and Team columns',
          {
            link: (
              <a href={ACCOUNT_OVERVIEW_BULK_USER_SPREADSHEET_URL}>
                {gt('this example Excel spreadsheet')}
              </a>
            ),
          }
        )}
      </p>
      <p>
        {gt(
          "On the next page, you'll see the list of members and have a chance to edit them, or correct any errors."
        )}
      </p>
      <p>
        {gt(
          "Once you confirm, we'll send the invitations to new members and email you when we finish."
        )}
      </p>
      <form
        method="POST"
        action={ACCOUNT_OVERVIEW_BULK_USER_UPLOAD_URL}
        encType="multipart/form-data"
      >
        <div className="form-group row">
          <input type="hidden" value={csrftoken} name="csrfmiddlewaretoken" />
          <label className="col-form-label col-lg-2">
            {gt('Spreadsheet file')}
          </label>
          <div className="col-lg-10">
            <input
              type="file"
              name="spreadsheet"
              className="form-control-file mb-4"
              accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            />

            <button type="submit" className="btn btn-primary">
              {gt('Upload Spreadsheet')}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
